<template>
  <v-container>
    <v-card class="custom-font" max-width="1200" flat>
      <v-card-title class="secondary--text font-weight-medium py-0">
        <v-row class="ma-0 py-6">
          <h3 class="my-2 mx-2 primary--text">
            {{ $t("settings.promotionCharge.title") }}
          </h3>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters align="center">
          <v-col cols="8" sm="6" md="4" class="">
            <v-text-field
              hide-details="auto"
              outlined
              dense
              :label="$t('settings.promotionCharge.defaultPrice')"
              color="secondary"
              type="number"
              class="numberClass"
              v-model="defaultPrice"
            >
            </v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2" sm="6" md="2" class="text-center">
            <v-btn
              class="white--text rounded-lg"
              color="primary"
              type="submit"
              :loading="btnLoading"
              @click="updateDefaultPrice"
            >
              {{ $t("common.update") }}
            </v-btn>
          </v-col>
          <v-btn
            class="rounded-lg white--text text-none"
            color="primary"
            @click="showRightSideDrawer('FEE')"
            depressed
          >
            <v-icon size="20" left>mdi-plus</v-icon>
            {{ $t("settings.promotionCharge.btnTitle") }}
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { updateDefaultPromotionCharges } from "../../methods/fee/update_default_price";
export default {
  data() {
    return {
      defaultPrice: "",
      btnLoading: false
    };
  },
  apollo: {
    getDefaultPromotionCharge() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/fee/default_promotion_charge_query.graphql"),
        result({ data }) {
          // , loading, networkStatus, refetch
          this.defaultPrice = data.getDefaultPromotionCharge;
          this.loading = false;
        }
      };
    }
  },
  computed: {
    ...mapGetters(["appSettings"])
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    updateDefaultPrice() {
      this.btnLoading = true;
      const updateInput = {
        settingsId: this.appSettings._id,
        defaultPromotionCharge: Number(this.defaultPrice)
      };
      updateDefaultPromotionCharges(updateInput).then(response => {
        if (response.data) {
          this.btnLoading = false;
          this.$apollo.queries.getDefaultPromotionCharge.refetch();
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("common.updateSuccess"),
            color: "green"
          });
        }
        if (response.graphQLErrors) {
          this.btnLoading = false;
          this.isError = response.graphQLErrors[0].message;
        }
      });
    }
  }
};
</script>

<style></style>
